export default __webpack_public_path__ + "static/media/laptop.eddaf500.png";